
/* injects from baggage-loader */

'use strict';

import config from './index.config';
import run from './index.run';

import uiRouter from '@uirouter/angularjs';

import coreModule from './core/core.module';
import indexComponents from './index.components';
import indexRoutes from './index.routes';
import loginModule from './pages/login/login.module';
import mainModule from './pages/main/main.module';
import sabedoriaModule from './pages/sabedoria/sabedoria.module';
import imaginacaoModule from './pages/imaginacao/imaginacao.module';
import pensamentoModule from './pages/pensamento/pensamento.module';
import endingModule from './pages/ending/ending.module';
import tetraModule from './pages/tetraedro/tetraedro.module';


const App = angular.module(
  "template", [
    // plugins
    uiRouter,
    "ngAnimate", 
    "ngCookies", 
    "ngTouch", 
    "ngSanitize", 
    "ngMessages", 
    "ngAria",
    "ngMask",
    "ng-sortable",
    "ang-drag-drop",
    'ui.bootstrap',

    // core
    coreModule.name,

    // components
    indexComponents.name,

    // routes
    indexRoutes.name,

    // pages
    loginModule.name,
    mainModule.name,
    sabedoriaModule.name,
    imaginacaoModule.name,
    pensamentoModule.name,
    endingModule.name,
    tetraModule.name
    ]
    );

App
.config(config)
.run(run);



export default App;



// WEBPACK FOOTER //
// ./src/app/index.module.js